import React, { useCallback } from 'react';
import { Box, DialogContent, DialogTitle } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useCarouselRequest } from '../../hooks/carouselRequest';

interface FormData {
  photoFilename: string;
}

interface CreateCarouselProps {
  setDialogOpen: (open: boolean) => void;
  refreshCarousels: () => void; // Add this prop
}

const validationSchema = yup.object().shape({
  photoFilename: yup.string().required("Photo filename is required")
});

const CreateCarousel: React.FC<CreateCarouselProps> = ({ setDialogOpen, refreshCarousels }) => {
  const carouselRequest = useCarouselRequest();
  const { control, handleSubmit, formState: { errors } } = useForm<FormData>({
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = useCallback(async (data: FormData) => {
    const dispatchData = await carouselRequest({ method: 'POST', data, id: null });
    if (dispatchData.meta.requestStatus === 'fulfilled') {
      setDialogOpen(false);
      refreshCarousels();
    }
  }, [carouselRequest, setDialogOpen, refreshCarousels]);

  return (
    <DialogContent>
      <DialogTitle sx={{ p: 0 }}>Add New Carousel</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Controller
          name="photoFilename"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              autoFocus
              sx={{ width: 300 }}
              {...field}
              label="File Name"
              variant="standard"
              error={!!errors.photoFilename}
              helperText={errors.photoFilename ? errors.photoFilename.message : ''}
              fullWidth
              margin="normal"
            />
          )}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
          <Button sx={{ mr: 2 }} onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">Save</Button>
        </Box>
      </form>
    </DialogContent>
  );
}

export default CreateCarousel;
